import * as React from "react";
const SvgFiRrGuitars = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-guitars_svg__a)">
      <path
        fill="#062147"
        d="M22.668 16.94c-.475-.769-.85-1.376-.85-2.122 0-.784.186-1.366.421-2.104.279-.875.626-1.963.729-3.653a1 1 0 0 0-1.96-.336c-.172.602-.797 1.904-3.009 2.209V1a1 1 0 0 0-1.831-.556l-.011-.028s-2.158 2.543-2.158 4.085c0 .5 1.08 1.436 2 1.5v4.929c-2.837-.427-2.992-2.657-3-2.945a1 1 0 0 0-1-.985h-.004a1 1 0 0 0-.996 1c0 2.33.422 3.652.76 4.714.235.737.421 1.32.421 2.104 0 .746-.375 1.353-.85 2.122-.593.959-1.332 2.154-1.332 3.878 0 2.517 2.795 3.182 4.273 3.182h5.454c1.478 0 4.273-.665 4.273-3.182 0-1.724-.738-2.918-1.332-3.878zM19.727 22h-5.454C14.25 22 12 21.949 12 20.818c0-1.156.501-1.967 1.033-2.827.539-.872 1.149-1.859 1.149-3.173 0-1.01-.213-1.756-.454-2.518.839.428 1.913.7 3.272.7 1.373 0 2.436-.263 3.258-.654-.235.747-.44 1.483-.44 2.473 0 1.314.61 2.302 1.149 3.173.531.859 1.033 1.671 1.033 2.827C22 21.955 19.747 22 19.727 22M9 1.5v1.046c0 .62-.192 1.226-.551 1.732L8 4.914v3.119l.073.005a1 1 0 0 1-.072 1.997V15a1 1 0 0 1-2 0v-4.963c-1.991.156-3 .815-3 1.963 0 .306.218.726.429 1.132.281.542.571 1.102.571 1.743 0 .827-.494 1.461-.971 2.074-.529.679-1.029 1.321-1.029 2.26 0 1.342 1.912 2.792 5 2.792a1 1 0 0 1 0 2c-3.991 0-7-2.06-7-4.792 0-1.626.838-2.702 1.451-3.488.205-.263.547-.703.549-.845 0-.153-.201-.54-.347-.822-.291-.561-.653-1.26-.653-2.053 0-1.393.678-3.665 5-3.966V4.93l-.441-.618a3 3 0 0 1-.559-1.744V1.501a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5zM19 19a1 1 0 0 1-1 1h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-guitars_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGuitars;
